import { FunctionalComponent, h } from 'preact';
import { useContext } from 'preact/compat';
import { WidgetContext } from '../../widget.context';
import { API_URL } from '../../constants';
import { Icon } from '../Icon/icon';
import { Checkbox } from '../Checkbox';
import { cn, isSharpenOrLocal, requestOptions } from '../../utilities';
import { EQuestionTypeDisplay, IComment } from '../QuestionsContainer';
import './style.css';

export interface ICommentProps {
  question: IComment;
  isUsersHidden?: boolean;
  onMouseDown: (idx: number) => void;
  onMouseUp: () => void;
  onDragStart: (idx: number) => void;
  onDragEnd: () => void;
  onDragOver: (idx: number, e: DragEvent) => void;
  onDrop: (target: number) => void;
  draggable?: boolean;
  onDeleteClick: (questionId: number) => void;
}

const Question: FunctionalComponent<ICommentProps> = (props) => {
  const { rootData } = useContext(WidgetContext);

  const openInNewTab = (questionId: number): void => {
    window.open(`https://develop.curriculum.com/tutorial-session-question/${questionId}`);
  };

  const onCheckNotes = (event: Event, questionId: number) => {
    const target: HTMLInputElement = event.target as HTMLInputElement;
    if (target.checked) {
      fetch(
        `${API_URL}/tutorial-session/questions/${questionId}/add-sharpen-note`,
        requestOptions(rootData?.token, 'POST'),
      ).then(() => {
        target.disabled = true;
      });
    }
  };

  const removeIMGs = (html: string): string => html.replace(/<img([\w\W]+?)\/>/gm, '');

  return (
    <div
      class={cn('cw-comment', props.question.questionType, isSharpenOrLocal ? 'SHARPEN' : '')}
      onDragStart={props.onDragStart.bind(this, props.question.id)}
      onDragEnd={props.onDragEnd}
      onDragOver={(e) => props.onDragOver(props.question.id, e)}
      onDrop={props.onDrop.bind(this, props.question.id)}
      draggable={props.draggable}
    >
      <div
        class="cw-comment__dnd"
        onMouseDown={props.onMouseDown.bind(this, props.question.id)}
        onMouseUp={props.onMouseUp}
      >
        <Icon icon="drag-n-drop" width="20px" height="20px" class="cw-comment__dnd-icon" />
      </div>

      {isSharpenOrLocal && (
        <Checkbox class="cw-comment__checkbox" onCheck={(e) => onCheckNotes(e, props.question.id)} />
      )}
      <div class="cw-comment__type">{EQuestionTypeDisplay[props.question.questionType]}</div>
      <div class="cw-comment__text" dangerouslySetInnerHTML={{ __html: removeIMGs(props.question.question) }} />
      {!props.isUsersHidden && (
        <div class="cw-comment__mentions">
          {props.question.mentionedStudents.map((user) => (
            <span key={`${user.id}_${user.studyYear}`} class="cw-mention__user">
              {`@${user.firstName} ${user.lastName}`}
            </span>
          ))}
        </div>
      )}

      <div class="cw-comment__open">
        <Icon icon="external-link" width="20px" height="20px" onClick={() => openInNewTab(props.question.id)} />
      </div>

      <div class="cw-comment__delete">
        <Icon icon="x" width="20px" height="20px" onClick={() => props.onDeleteClick(props.question.id)} />
      </div>
    </div>
  );
};

Question.defaultProps = {
  isUsersHidden: false,
  draggable: false,
};

export { Question };
